export default __webpack_public_path__ + "static/media/iwatchtv-light-logo-V2.9e4772fd.png";